<template>
  <div v-if="!isLoadingPage" class="fluid" id="performanceReportList">
    <div v-if="permission != null">
      <div v-if="permission.read_perm == 1">
        <div class="performanceReport-list-div">
          <v-card elevation="0" class="px-3 py-2" style="width: 100%">
            <v-row>
              <v-col
                cols="12"
                class="d-flex"
                style="
                  position: relative;
                  padding: 0 20px;
                  text-align: center;
                  margin-top: 20px;
                "
              >
                <h4
                  class="indigo--text"
                  style="font-weight: bold; margin: auto"
                >
                  SAFETY PERFORMANCE REPORT
                  <v-tooltip bottom color="grey">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        text
                        icon
                        color="grey darken-2"
                        @click="getDataFromApi"
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>refresh page</span>
                  </v-tooltip>
                </h4>
              </v-col>
              <v-col cols="12">
                <div>
                  <v-toolbar
                    class="group-list-toolbar-1"
                    flat
                    style="
                      height: 60px;
                      border-radius: 10px 10px 0 0;
                      padding-top: 15px;
                    "
                  >
                    <div class="d-flex align-content-start">
                      <div
                        style="margin-right: 15px; height: 45px"
                        class="d-flex justify-center align-center"
                      >
                        <v-btn
                          style="font-size: 12px"
                          @click="addPerformanceReport"
                          elevation="2"
                          tilerounded="5px"
                          color="primary"
                          class="white--text"
                          small
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small class="">
                                mdi-plus
                              </v-icon>
                            </template>
                            <span>Tambah Report</span>
                          </v-tooltip>
                        </v-btn>
                      </div>
                    </div>
                    <div style="width: 210px; height: 45px">
                      <v-autocomplete
                        v-model="paramAPI.company_id"
                        label="Perusahaan"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="companyWatcher"
                        :items="dropdown.company"
                        :disabled="isDisableCompanyDropdown"
                      ></v-autocomplete>
                    </div>
                    <div style="width: 180px; height: 45px; margin-left: 15px">
                      <v-autocomplete
                        v-model="paramAPI.status"
                        label="Status"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="statusWatcher"
                        :items="dropdown.status"
                      ></v-autocomplete>
                    </div>
                    <div
                      style="
                        height: 42px;
                        margin-top: 5px;
                        margin-bottom: 8px;
                        margin-left: 10px;
                      "
                      class="d-flex"
                    >
                      <v-text-field
                        class="ml-1 mr-2"
                        dense
                        label="Bulan"
                        type="month"
                        name="month"
                        style="height: 30px"
                        step="1"
                        v-model="paramAPI.date"
                        @change="monthWatcher"
                        outlined
                        clearable
                      />
                    </div>
                    <div
                      style="width: 30%; margin-left: auto; margin-top: 19.5px"
                    >
                      <v-text-field
                        v-model="paramAPI.keyword"
                        @keyup.enter="searchEnter"
                        label="Search here"
                        type="search"
                        append-icon="mdi-magnify"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </v-toolbar>
                </div>
              </v-col>

              <v-col cols="12" style="width: 100%">
                <v-data-table
                  v-if="result.length > 0 || !skeleton_loading"
                  mobile-breakpoint="0"
                  fixed-header
                  height="50vh"
                  :headers="headers"
                  style="cursor: pointer"
                  :items="result"
                  :loading="loading"
                  @click:row="rowClick"
                  item-key="id"
                  :options.sync="options"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                  }"
                  :server-items-length="totalData"
                  :page="paramAPI.page"
                  @update:page="updatePage"
                  :items-per-page="paramAPI.itemsPerPage"
                  @update:items-per-page="updateItemPerPage"
                >
                  <!-- <template v-slot:[`item.no`]="{ index }">
                        <div
                            style="
                            font-size: 14px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                            "
                        >
                            {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                        </div>
                        </template> -->
                  <template v-slot:[`item.name`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.name }}
                    </div>
                  </template>
                  <template v-slot:[`item.document_no`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.document_no }}
                    </div>
                  </template>
                  <template v-slot:[`item.company_name`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.company_name }}
                    </div>
                  </template>
                  <template v-slot:[`item.pic_name`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.pic_name }}
                    </div>
                  </template>
                  <template v-slot:[`item.report_date`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.report_date }}
                    </div>
                  </template>
                  <template v-slot:[`item.total_employee`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.total_employee }}
                    </div>
                  </template>
                  <template v-slot:[`item.total_other_people`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.total_other_people }}
                    </div>
                  </template>
                  <template v-slot:[`item.workdays`]="{ item }">
                    <div
                      style="
                        width: 60px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.workdays }}
                    </div>
                  </template>
                  <template v-slot:[`item.createdAt`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.createdAt) }}
                    </div>
                  </template>
                  <template v-slot:[`item.updatedAt`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.updatedAt) }}
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div
                      style="
                        width: 40px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                      "
                    >
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }"
                          ><v-icon
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="rowClick(item)"
                            small
                            color="primary"
                            class="mr-2"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="error"
                            @click.stop="deleteItem(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <div
                      :style="`
                                      color: ${itemStatusColor(
                                        item.status
                                      )}; font-weight: bold;
                                        font-size: 12px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;`"
                    >
                      {{ itemStatusName(item.status) }}
                    </div>
                  </template>
                </v-data-table>
                <v-skeleton-loader
                  v-else
                  style="width: 100%"
                  type="table-heading, table-tbody, table-tfoot"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <v-dialog
          v-model="performanceReportDialog"
          persistent
          max-width="500px"
        >
          <v-card v-if="form !== null">
            <v-card-title>
              <span class="text-h5">Add/Edit Report</span>
            </v-card-title>
            <v-form ref="entryForm2" @submit.prevent="savePerformanceReport">
              <v-card-text>
                <v-container>
                  <v-row>
                    <!-- <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Nama Dokumen
                      </p>
                      <v-text-field
                        v-model="form.name"
                        :rules="rules.nameRules"
                        dense
                        outlined
                        style="height: 45px"
                      />
                    </v-col> -->
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Perusahaan
                      </p>
                      <v-autocomplete
                        v-model="form.company"
                        :items="dropdown.company"
                        :rules="rules.companyRules"
                        item-text="name"
                        item-value="id"
                        return-object
                        dense
                        outlined
                        clearable
                        style="height: 45px"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        PIC
                      </p>
                      <v-autocomplete
                        v-model="form.pic"
                        :items="dropdown.employee"
                        :rules="rules.picRules"
                        :search-input.sync="employeeSearch"
                        style="height: 45px"
                        label="Ketik nama"
                        item-text="name"
                        item-id="id"
                        return-object
                        dense
                        clearable
                        outlined
                        hide-details
                        hide-no-data
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-avatar>
                              <img :src="`${data.item.photo}`" />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ data.item.name }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ data.item.company_name }}-{{ data.item.nik }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Bulan
                      </p>
                      <v-text-field
                        v-model="form.report_date"
                        :rules="rules.dateRules"
                        type="month"
                        name="month"
                        step="1"
                        dense
                        outlined
                      />
                    </v-col>
                    <v-col cols="6"></v-col>

                    <v-col cols="4" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Total Karyawan
                      </p>
                      <v-text-field
                        v-model="form.total_employee"
                        type="number"
                        min="0"
                        dense
                        outlined
                      />
                    </v-col>
                    <v-col cols="4" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Orang Lain
                      </p>
                      <v-text-field
                        v-model="form.total_other_people"
                        type="number"
                        min="0"
                        dense
                        outlined
                      />
                    </v-col>
                    <v-col cols="4" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Hari Kerja
                      </p>
                      <v-text-field
                        v-model="form.workdays"
                        type="number"
                        min="0"
                        dense
                        outlined
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closePerformanceReportDialog"
                >
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import buildType from '../../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'dssk3performancereportlist',
  data: () => ({
    performanceReportDialog: false,
    config: require('../../../../services/config.json')[env],
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    hrsApi: buildType.apiURL('hrs'),
    build: process.env.VUE_APP_BUILD_TYPE,
    isLoadingPage: true,
    permission: null,
    appLevel: null,
    userLevel: null,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      status: null,
      date: null
      // department_id: null
    },
    totalData: 0,
    form: null,
    detail: null,
    isEdit: false,

    options: {},
    actionValue: 0,
    result: [],
    loading: false,
    isDisableCompanyDropdown: false,
    rules: {
      // nameRules: [],
      picRules: [],
      companyRules: [],
      dateRules: [],
      workdayRules: []
    },
    dropdown: {
      company: [],
      status: [
        {
          name: 'Draft',
          id: 0
        },
        {
          name: 'Waiting Approval',
          id: 1
        },
        {
          name: 'Done',
          id: 2
        },
        {
          name: 'Cancel',
          id: 3
        },
        {
          name: 'Reject',
          id: 4
        }
      ],
      employee: []
    },
    skeleton_loading: true,
    employeeSearch: null,
    employeeSelect: null
  }),

  async mounted() {
    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    // if (this.getShiftSettingPageQuery !== null) {
    //   this.paramAPI = this.getShiftSettingPageQuery
    // }
    await this.getDataMenu()
    // await this.initDropdown()
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getPerformanceReportPageQuery']),
    headers() {
      const xArr = [
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'No',
          value: 'document_no',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'Nama',
        //   value: 'name',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'Perusahaan',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'PIC',
          value: 'pic_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Bulan',
          value: 'report_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jml. Karyawan',
          value: 'total_employee',
          align: 'left',
          sortable: false
        },
        {
          text: 'Orang lain',
          value: 'total_other_people',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hari Kerja',
          value: 'workdays',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'Created at',
        //   value: 'createdAt',
        //   align: 'left',
        //   sortable: false
        // },
        // {
        //   text: 'updated at',
        //   value: 'updatedAt',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'Option',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]

      return xArr
    }
  },
  watch: {
    employeeSearch(val) {
      if (val !== '') {
        val && val !== this.employeeSelect && this.querySelections(val)
      } else {
        this.employeeSelect = null
        this.dropdown.employee = []
      }
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setPerformanceReportPageQuery']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2] + '/' + split[3]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },

    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      if (this.userLevel.user_user_level.allowed_company !== null) {
        if (
          this.userLevel.user_user_level.allowed_company.find(
            ({ id }) => id == this.getUserProfile.employee.company.plant_id
          ) !== undefined
        ) {
          this.paramAPI.company_id = Number(
            this.getUserProfile.employee.company.plant_id
          )
        } else {
          this.paramAPI.company_id = Number(
            this.userLevel.user_user_level.allowed_company[0].id
          )
        }
      } else {
        this.paramAPI.company_id = Number(
          this.getUserProfile.employee.company.plant_id
        )
      }
      if (this.getPerformanceReportPageQuery != null) {
        this.paramAPI = this.getPerformanceReportPageQuery
      }
      setTimeout(async () => {
        await this.getDataFromApi()
        await this.initDropdown()
      }, 200)
    },
    async initDropdown() {
      this.dropdownCompany()
    },
    resetSomeParam() {
      this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.offset = 0
      this.paramAPI.page = 1
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    companyWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    statusWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    monthWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    async dropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) =>
          id == this.appLevel.administrator || id == this.appLevel.adminK3
      )
      let xFlag = false
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            xFlag = true
          } else {
            this.dropdown.company = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          xFlag = true
        }
      } else {
        xFlag = true
      }

      if (xFlag) {
        if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
          this.isDisableCompanyDropdown = true
        } else {
          this.isDisableCompanyDropdown = false
        }
        axios
          .get(`${this.eSanqua}master/universal/plant/dropdown`)
          .then((res) => {
            this.dropdown.company = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = data.total_record
            return (this.result = data.data)
          }
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      let url = `${this.dssApi}performancereport/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }`
      const filter = []
      if (this.paramAPI.date !== null) {
        // filter.push(`{"date": ${this.paramAPI.date}}`)
        url = url + `&date=${this.paramAPI.date}`
      }
      if (this.paramAPI.company_id !== null) {
        filter.push(`{"company_id": ${this.paramAPI.company_id}}`)
      }
      url = url + `&filter=[${filter}]`
      this.setPerformanceReportPageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },

    rowClick(pItem) {
      setTimeout(() => {
        this.$router.push(`performancereport/detail/${pItem.id}`)
      }, 100)
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .delete(`${this.dssApi}performancereport/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    addPerformanceReport() {
      this.form = {
        act: 'add',
        name: null,
        company: null,
        report_date: null,
        pic: null,
        total_employee: null,
        total_other_people: null,
        workdays: null
      }
      setTimeout(() => {
        this.performanceReportDialog = !this.performanceReportDialog
      }, 300)
    },
    savePerformanceReport() {
      // this.rules.nameRules = [(v) => !!v || 'Name is required']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm2.validate()) {
          const form = {
            act: self.form.act,
            // name: self.form.name,
            company_id: self.form.company.id,
            company_name: self.form.company.name,
            pic_id: self.form.pic.id,
            pic_name: self.form.pic.name,
            report_date: self.form.report_date,
            total_employee: self.form.total_employee,
            total_other_people: self.form.total_other_people,
            workdays: self.form.workdays
          }
          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }
          console.log('save data>>>', form)

          self.submitPerformanceReport(form)
        }
      })
    },
    async submitPerformanceReport(form) {
      this.loading = true
      await axios
        .post(`${this.dssApi}performancereport/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
            this.closePerformanceReportDialog()
            setTimeout(() => {
              this.$router.push(
                `performancereport/detail/${res.data.created_id}`
              )
            }, 500)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closePerformanceReportDialog() {
      this.form = null
      setTimeout(() => {
        this.performanceReportDialog = false
      }, 300)
    },
    querySelections(v) {
      let url = `${this.hrsApi}employee/dropdown?keyword=${v}`
      if (this.form != null) {
        if (this.form.company != null) {
          url = url + `&company_id=${this.form.company.id}`
        }
      }
      axios
        .get(url)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              resArr.push({
                id: res.data.data[i].id,
                nik: res.data.data[i].nik,
                name: res.data.data[i].name,
                company_id: res.data.data[i].company_id,
                company_name: this.getCompanyAlias(res.data.data[i].company_id),
                photo: res.data.data[i].photo
              })
            }
            return (this.dropdown.employee = resArr)
          }
          return (this.dropdown.employee = [])
        })
        .catch((err) => {
          this.dropdown.employee = []
          return console.log(err)
        })
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    },
    itemStatusColor(val) {
      console.log(val)

      if (val) {
        if (val == -1) {
          return 'red'
        } else {
          const arrColour = ['black', 'orange', 'green', 'red', 'red']
          return arrColour[val.id]
        }
      }
    },
    itemStatusName(val) {
      const arrStatus = [
        'Draft',
        'Waiting Approval',
        'Done',
        'Cancel',
        'Reject'
      ]
      return arrStatus[val.id]
    }
  }
}
</script>
<style lang="scss">
#performanceReportList {
  position: relative;
  .performanceReport-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .bodypart-list-toolbar2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #performanceReportList {
    .performanceReport-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .bodypart-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
